import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { MissionComponent } from "./components/MissionComponent";
import { AudioComponent } from "./components/AudioComponent";
import { OverlayComponent } from "./components/OverlayComponent";
import { FishGameComponent } from "./components/FishGameComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("mission-canvas", MissionComponent);
window.customElements.define("fish-minigame", FishGameComponent);
window.customElements.define("audio-canvas", AudioComponent);
window.customElements.define("overlay-canvas", OverlayComponent);
